const rejectionReasons = Object.freeze({
  other: 'other',
  informationMismatch: 'informationMismatch',
});

export default rejectionReasons;
